import Vue from "vue";
import Vuex, { StoreOptions } from "vuex";
import { RootState } from "../types";
import { pageData } from "./pageData";
import { projectData } from "./projectData";
import { AuthenticationData } from "./auth";
import { GlobalData } from "./global";
import { ProfileData } from "./profileData";
import { menuData } from "./menu";
import animationData from "./animaion";
import { sociallinkData } from "./socialData";
import VueWow from "vue-wow";
import VueAwesomeSwiper from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";

Vue.use(VueAwesomeSwiper);
Vue.use(VueWow);
Vue.use(Vuex);

const store: StoreOptions<RootState> = {
  state: {
    version: "0.1.0"
  },
  modules: {
    pageData,
    projectData,
    menuData,
    animationData,
    sociallinkData,
    auth: AuthenticationData,
    global: GlobalData,
    profile: ProfileData
  }
};

export default new Vuex.Store<RootState>(store);
